import React from 'react';
import './AppleSpinner.css';

const AppleSpinner = ({ size = 40 }) => {
  return (
    <div className="apple-spinner-container">
      <div 
        className="apple-spinner" 
        style={{ 
          width: size, 
          height: size,
          borderWidth: size * 0.08
        }}
      >
        <div className="apple-spinner-inner"></div>
      </div>
    </div>
  );
};

export default AppleSpinner;
